import { render, staticRenderFns } from "./AssessData.vue?vue&type=template&id=04559e58&scoped=true"
import script from "./AssessData.vue?vue&type=script&lang=js"
export * from "./AssessData.vue?vue&type=script&lang=js"
import style0 from "./AssessData.vue?vue&type=style&index=0&id=04559e58&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04559e58",
  null
  
)

export default component.exports